import * as React from 'react';
import cx from 'classnames';

import {
  withStyles,
  WithStyles,
  createStyles,
  Theme,
} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import RefreshIcon from '@material-ui/icons/Refresh';

import units from 'ha/theme/units';
import { IntlProps } from 'ha/i18n';
import Track from 'ha/components/track/SmartTrack';

interface OwnProps {
  isAutoSearchEnabled: boolean;
  isOutdated: boolean;
  onMapUpdate: () => void;
  toggleMapAutoSearch: (isAutoSearchDisabled: boolean) => void;
  isMobileMapOpen: boolean;
}

const styles = (t: Theme) =>
  createStyles({
    refreshButtonIcon: {
      marginRight: t.spacing.unit,
    },
    container: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      margin: units.rem(1.5),
    },
    containerMobile: {
      margin: units.rem(0.75),
    },
    checkbox: {
      background: 'white',
      paddingRight: units.rem(1),
      margin: 0,
    },
  });

type Props = OwnProps & IntlProps & WithStyles<typeof styles>;

export class SearchMapAutoRefresh extends React.Component<Props> {
  handleAutoSearchChange = () => {
    const { isAutoSearchEnabled, toggleMapAutoSearch } = this.props;

    toggleMapAutoSearch(!isAutoSearchEnabled);
  };

  render() {
    const {
      classes,
      isAutoSearchEnabled,
      isOutdated,
      isMobileMapOpen,
      onMapUpdate,
      intl: { T },
    } = this.props;

    const positionClass = cx(classes.container, {
      [classes.containerMobile]: isMobileMapOpen,
    });

    const control =
      !isAutoSearchEnabled && isOutdated ? (
        <Button color="secondary" onClick={onMapUpdate} variant="contained">
          <RefreshIcon className={classes.refreshButtonIcon} />
          {T('Refresh search result')}
        </Button>
      ) : (
        <Track
          name="Toggled Search as the map moves"
          enabled={!isAutoSearchEnabled}
          type="button"
        >
          <FormControlLabel
            className={classes.checkbox}
            control={
              <Checkbox
                checked={isAutoSearchEnabled}
                onChange={this.handleAutoSearchChange}
                value="toggleAutoSearch"
              />
            }
            label={T('Search as the map moves')}
          />
        </Track>
      );

    return <div className={positionClass}>{control}</div>;
  }
}

export default withStyles(styles)(SearchMapAutoRefresh);
